module.exports = __webpack_public_path__ + "img/public/SiteIcons/steering-1.png?43094122";